import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Pessoa} from "../../../domain/Pessoa";

@Injectable()
export class PessoaHttpService extends AbstractHttpService<Pessoa>{
    url = '/api/pessoa';
}
